import { render } from "./Main.vue?vue&type=template&id=00768c5e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=00768c5e&scoped=true&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00768c5e"]])

export default __exports__